"use client";

import React from "react";
import { MapPin, Phone, Mail, Facebook, Twitter, Instagram, Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
const services = ["House Cleaning", "Deep Cleaning", "Move-In / Out", "Organizing", "Renovation", "Commercial"];
const socials = [{
  icon: Facebook,
  label: "Facebook",
  href: "#"
}, {
  icon: Twitter,
  label: "Twitter",
  href: "#"
}, {
  icon: Instagram,
  label: "Instagram",
  href: "#"
}, {
  icon: Linkedin,
  label: "LinkedIn",
  href: "#"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-32 bg-primary/5 animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="#" className="text-foreground/70 hover:text-primary transition-colors duration-200 font-default text-sm">Home</Link>
        </li>
        <li data-index={1}>
          <Link to="#" className="text-foreground/70 hover:text-primary transition-colors duration-200 font-default text-sm">Services</Link>
        </li>
        <li data-index={2}>
          <Link to="#" className="text-foreground/70 hover:text-primary transition-colors duration-200 font-default text-sm">Why Choose Us</Link>
        </li>
        <li data-index={3}>
          <Link to="#" className="text-foreground/70 hover:text-primary transition-colors duration-200 font-default text-sm">Contact</Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-foreground/70 hover:text-primary transition-colors duration-200 font-default text-sm">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="202197" id="footer" className="bg-secondary text-foreground pt-20 pb-10 border-t border-border/50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16">
          
          <div className="flex flex-col space-y-8">
            <Link to="#" className="inline-block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623166/img/easylocal_cleaning_logo.png" alt="EasyLocal Cleaning" className="h-7 w-auto" />
            </Link>
            <div className="space-y-5 text-sm text-foreground/80 font-default">
              <div className="flex items-start gap-3">
                <MapPin className="size-4 shrink-0 text-primary/60 mt-0.5" />
                <span>Winter Park, Florida</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="size-4 shrink-0 text-primary/60" />
                <span>(407) 717-9881</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="size-4 shrink-0 text-primary/60" />
                <Link to="mailto:lc121108819@gmail.com" className="hover:text-primary transition-colors duration-200">
                  lc121108819@gmail.com
                </Link>
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-serif text-xl font-medium mb-6 text-primary tracking-tight">
              Explore
            </h3>
            <MenuProvider menu_id="header_menu">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div>
            <h3 className="font-serif text-xl font-medium mb-6 text-primary tracking-tight">
              Our Services
            </h3>
            <ul className="space-y-3">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to="#" className="text-sm text-foreground/70 hover:text-primary transition-colors duration-200 line-clamp-1 font-default">
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div>
            <h3 className="font-serif text-xl font-medium mb-6 text-primary tracking-tight">
              Connect
            </h3>
            <div className="flex flex-wrap gap-3 mb-8">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <Button key={i} data-index={i} variant="outline" size="icon" className="rounded-full bg-transparent border-primary/10 text-primary hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-300 shadow-none" asChild>
                    <Link to={social.href} aria-label={social.label}>
                      <Icon className="size-4" />
                    </Link>
                  </Button>;
            })}
            </div>
            <div className="flex flex-col gap-3 items-start">
              <Badge variant="outline" className="bg-primary/5 text-primary/80 border-primary/10 px-4 py-1.5 text-[10px] font-medium tracking-widest uppercase rounded-full shadow-none">
                Licensed & Insured
              </Badge>
              <Badge variant="outline" className="bg-primary/5 text-primary/80 border-primary/10 px-4 py-1.5 text-[10px] font-medium tracking-widest uppercase rounded-full shadow-none">
                Detail Focused
              </Badge>
            </div>
          </div>

        </div>

        <div className="mt-20">
          <Separator className="bg-primary/10 h-[1px] w-full mb-8" />
          <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-[11px] text-foreground/50 font-default uppercase tracking-widest">
            <p className="text-center md:text-left">
              &copy; {currentYear} EasyLocal Cleaning. All rights reserved.
            </p>
            <div className="flex gap-10">
              <Link to="#" className="hover:text-primary transition-colors duration-200">
                Privacy Policy
              </Link>
              <Link to="#" className="hover:text-primary transition-colors duration-200">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}